var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-hamburger",attrs:{"type":"button","aria-label":_vm.$t('Open menu'),"data-testid":"menuButton"},on:{"click":_vm.openSidebarMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }